import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ManualTaxInvoiceNewPage = lazy(
  () => import("@/pages/tools.manual-tax-invoices.new.page"),
);

export const Route = createFileRoute("/tools/manual-tax-invoices/new")({
  component: ManualTaxInvoiceNewPage,
});
